
































import { Component, Vue, Prop } from "vue-property-decorator";
import { deleteManual } from "../api";

import { namespace } from "vuex-class";
import { ManualModel } from "../models";
import { SnackbarInterface } from "shared/store/snackbar/state";

const snackStore = namespace("snackbar");

@Component
export default class RemoveManual extends Vue {
  @snackStore.Mutation setSnackbar!: (payload: SnackbarInterface) => void;
  @Prop({ required: true, type: Boolean }) public value!: boolean;
  @Prop({ required: true })
  manual!: ManualModel;

  get dialog(): boolean {
    return this.value;
  }
  set dialog(v: boolean) {
    this.$emit("input", v);
  }

  async deleteManual() {
    this.dialog = false;
    try {
      await deleteManual(this.manual.id);
      this.$emit("listChanged");
    } catch (e) {
      this.setSnackbar({
        text: this.$t("manuals.texts.deleteError").toString(),
        color: "error"
      });
    }
  }
}
